import { Link, Outlet } from 'react-router';
import { canUseManagement, roleHome } from '@/auth/roles';
import { useStaffSession } from '@/auth/react';
import { buttonClasses } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';
import { ManageHeader } from '@/shells/ManageShell';

/**
 * Management screens are for the branch manager. Any other role sees "Not allowed" under the plain header,
 * with no management tab strip or rail, and no management request is made: the screens below are not even
 * mounted. A hint for what to show; the backend still decides.
 */
export function ManageGate() {
  const role = useStaffSession()?.user.role;
  if (!role) return null;
  if (!canUseManagement(role)) {
    const home = roleHome(role);
    return (
      <div className="flex min-h-dvh flex-col bg-canvas">
        <ManageHeader />
        <main id="main" tabIndex={-1} className="flex-1 px-4 py-4 md:px-6 md:py-6">
          <EmptyState
            icon="alert"
            title="Not allowed"
            message="You don't have access to management."
            // A role whose home is this very area has nowhere else to go, so no link back to it.
            action={
              home.startsWith('/manage') ? undefined : (
                <Link to={home} className={buttonClasses({ variant: 'secondary' })}>
                  Go to your home screen
                </Link>
              )
            }
          />
        </main>
      </div>
    );
  }
  return <Outlet />;
}

/** A wrong address inside management: the shell and its navigation stay, and the way back is the overview. */
export function ManageNotFound() {
  return (
    <EmptyState
      icon="alert"
      title="Page not found"
      message="That page doesn't exist."
      action={
        <Link to="/manage" className={buttonClasses({ variant: 'secondary' })}>
          Back to overview
        </Link>
      }
    />
  );
}
